import CryptoJS from "crypto-js";
import jwtEncode from "jwt-encode";
import { jwtDecode } from "jwt-decode";

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY; // Use environment variables in production
const TOKEN_SECRET = process.env.REACT_APP_TOKEN_SECRET; // Separate secret for token

// Encrypt data
export const encryptData = (data) => {
  const ciphertext = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    SECRET_KEY,
  ).toString();
  return encodeURIComponent(ciphertext); // Encode for URL safety
};

// Generate JWT Token (5 min expiry)
export const generateToken = (secreteToken) => {
  const payload = {
    ...secreteToken,
    exp: Math.floor(Date.now() / 1000) + 60 * 5, // Expires in 5 minutes
  };

  return jwtEncode(payload, TOKEN_SECRET);
};

// Decrypt Data
// export const decryptData = async (ciphertext) => {
//   try {
//     const bytes = CryptoJS.AES.decrypt(
//       decodeURIComponent(ciphertext),
//       SECRET_KEY
//     );
//     console.log(bytes.toString(CryptoJS.enc.Utf8));
//     return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
//   } catch (error) {
//     console.log("decryptData error", error);
//     return null; // Invalid decryption
//   }
// };

function getCryptoJSKey(secretKey) {
  const encoder = new TextEncoder();
  const utf8 = encoder.encode(secretKey);
  const sliced = utf8.slice(0, 32);
  const binary = String.fromCharCode(...sliced);
  const base64Key = btoa(binary);
  return CryptoJS.enc.Base64.parse(base64Key);
}

export const decryptData = async (encryptedString) => {
  try {
    const decoded = decodeURIComponent(encryptedString);
    const [ivBase64, encryptedBase64] = decoded.split(":");
    console.log("ivBase64", ivBase64);
    const key = getCryptoJSKey(SECRET_KEY);
    const iv = CryptoJS.enc.Base64.parse(ivBase64);
    const ciphertext = CryptoJS.enc.Base64.parse(encryptedBase64);
    console.log("ciphertext", ciphertext.toString(CryptoJS.enc.Base64));
    const decrypted = CryptoJS.AES.decrypt({ ciphertext }, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    console.log("decrypted", decrypted.toString(CryptoJS.enc.Utf8));
    const plaintext = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(plaintext);
  } catch (e) {
    throw new Error("Decryption failed: " + e.message);
  }
};

// Verify JWT Token (Checks Expiry)
// export const verifyToken = async (token) => {
//   try {
//     const decodedToken = jwtDecode(token);
//     return decodedToken && decodedToken.exp * 1000 > Date.now()
//       ? decodedToken
//       : null;
//   } catch (error) {
//     console.log("verify token error", error);
//     return null; // Invalid or expired token
//   }
// };

export const verifyToken = async (token) => {
  try {
    const decoded = jwtDecode(token); // No need for secret key in decode

    const currentTime = Date.now() / 1000;
    if (decoded.exp && decoded.exp < currentTime) {
      console.warn("⚠️ Token has expired");
      return null;
    }

    return decoded;
  } catch (err) {
    console.error("❌ Failed to decode token:", err.message);
    return null;
  }
};
